
<div class="dialog-header">
    <h2 mat-dialog-title>Thank You!</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>

<mat-dialog-content class="dialog-content">
  <p>Your feedback was successfully posted.</p>
  <p>As we work towards improvements to the new Time Keeping System your comments will be taken into consideration.</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-flat-button (click)="close()">Close</button>
</mat-dialog-actions>